import { styled, alpha } from '@mui/material/styles';
import { Avatar, Button, Icon, ListItem, ListItemSecondaryAction, Typography } from '@mui/material';

export const PadLeft = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}));

export const MarginBot = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})(({ theme, isHeader }) => ({
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  borderBottom: `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
  ...(isHeader ? { borderBottom: 'none' } : {}),
}));

export const ListItemHeader = styled('div')({
  fontSize: 20,
  fontWeight: 'bold',
});

export const ListItemSecondary = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})(({ theme, isHeader }) => ({
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(-4.5),
    marginTop: theme.spacing(isHeader ? 4 : 2),
  },
}));

export const ListItemActions = styled(ListItemSecondaryAction)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    top: 'inherit',
    bottom: theme.spacing(-3.5),
  },
}));

export const GreyIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.text.disabled,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const OrangeIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.warning.main,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const RedIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.error.main,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  marginRight: theme.spacing(1),
  alignSelf: 'flex-start',
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
}));

export const DatesText = styled(Typography)({
  fontSize: 13,
});

export const IssueBtn = styled(Button, {
  shouldForwardProp: (prop) => !['isHeader', 'selected'].includes(prop),
})(({ theme, isHeader, selected }) => ({
  backgroundColor: theme.palette.action.disabledBackground,
  pointerEvents: isHeader ? 'auto' : 'none',
  width: 65,
  height: 65,
  marginLeft: 5,
  flexDirection: 'column',
  color: theme.palette.text.primary,
  fontSize: 12,

  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.5),
  },

  ...(selected ? { backgroundColor: alpha(theme.palette.secondary.main, 0.5) } : {}),
}));

export const RowFlex = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});

export const UpdatedCol = styled('div')(({ theme }) => ({
  width: 110,
  [theme.breakpoints.down('sm')]: {
    width: 80,
  },
}));

export const CreateButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginLeft: 'auto',
}));
